var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"80px"}},[_c('iframe',{attrs:{"src":'https://docs.google.com/forms/d/e/'+_vm.routerLink+'/viewform?embedded=true',"width":"100%","height":"800","frameborder":"0","marginheight":"0","marginwidth":"0"}},[_vm._v("Loading…")])])
}
var staticRenderFns = []

export { render, staticRenderFns }